import React from 'react';
import './TagDisplay.css';

const TagDisplay = ({tagName = '?'}) => {
  const style = tagName?.length > 3 ? 'tagDisplay cap' : 'tagDisplay upp';
  return (
    <span className={style}>
      {tagName}
    </span>
  );
};

export default TagDisplay;